import { Alert, Button } from '@mui/material';
import { useState } from 'react';
import type { VolumeBatch } from '../../../api/src/fakes/query-volume';
import { api } from '../api/client';
import { Stack, Typography } from '../components/mui-system';

export function FakesVolumeStopButton({
  workspaceId,
  batch,
  disabled,
  onStopped,
}: {
  workspaceId: string;
  batch: VolumeBatch;
  disabled?: boolean;
  onStopped(): void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!batch.pending || batch.stop) return null;
  return (
    <Stack gap={1}>
      <Button
        color="warning"
        variant="outlined"
        disabled={disabled || busy}
        onClick={async () => {
          setBusy(true);
          setError('');
          try {
            await api.stopFakesVolumes(workspaceId, batch.id);
            onStopped();
          } catch (e) {
            setError(e instanceof Error ? e.message : 'Не удалось остановить сбор');
          } finally {
            setBusy(false);
          }
        }}
      >
        {busy ? 'Останавливаем…' : 'Остановить сбор'}
      </Button>
      <Typography variant="caption" color="text.secondary">
        Ещё не начатые обращения отменятся. Выполняющийся запрос завершится с сохранением
        результата. Месячное расписание останется включённым, если было включено.
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  );
}
